module.exports = new __parcel__URL__("estimates-app-skeleton.tpl.440d8209.svg").toString();